export default __webpack_public_path__ + "static/media/Home.ce29fe9c.png";